import { AnalystConsensusRating } from '@t/wheel/wheel.types';

export enum TextInputKeys {
  StrikeFrom = 'strikeFrom',
  StrikeTo = 'strikeTo',
  RoiFrom = 'roiFrom',
  RoiTo = 'roiTo',
  PremiumFrom = 'premiumFrom',
  PremiumTo = 'premiumTo',
  MarketCapFrom = 'marketCapFrom',
  MarketCapTo = 'marketCapTo',
  PERatioFrom = 'peRatioFrom',
  PERatioTo = 'peRatioTo',
  Dividends = 'dividends',
  ChangeInPercentFrom = 'changeInPercentFrom',
  ChangeInPercentTo = 'changeInPercentTo',
  DropInPercentFrom = 'dropInPercentFrom',
  DropInPercentTo = 'dropInPercentTo',
  PriceToAvgTargetFrom = 'priceToAvgTargetFrom',
  PriceToAvgTargetTo = 'priceToAvgTargetTo',
}

export interface IDisplayedFilterValues {
  flags: string;
  strike: string;
  roi: string;
  premium: string;
  marketCap: string;
  PERatio: string;
  changeInPercent: string;
  dropInPercent: string;
  consensusRatings: string;
  priceToAvgTarget: string;
}

export interface ConsensusRatingFilterModel {
  id: number;
  title: string;
  value: AnalystConsensusRating;
}
